var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigFire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 21,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 21,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 3,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 3,
    height: 3,
    fill: "#FF4D00"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 3,
    height: 3,
    fill: "#FC9700"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 15,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 3,
    height: 3,
    fill: "#FFC700"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFire);
export default __webpack_public_path__ + "static/media/bigFire.06abcc201028846ce8eba85b4315e784.svg";
export { ForwardRef as ReactComponent };